<!-- Loading bar -->
<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'" [navigation]="navigation.default" [opened]="sidebarOpen">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <div class="flex items-center w-full p-4 pl-6">
      <!-- Logo -->
      <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium"
        style="font-size: xx-large">
        SDMS
      </div>
    </div>
    <!-- User Profile Photo -->
    <!-- <div class="flex flex-col items-center w-full p-4">
      <button mat-icon-button [matMenuTriggerFor]="userActions">
        <div class="relative w-24 h-24">
          <img
            class="w-full h-full rounded-full"
            *ngIf="user.avatar"
            [src]="user.avatar"
            alt="User avatar"
          />
        </div>
      </button>

      <div class="flex flex-col items-center justify-center w-full mt-7">
        <div
          class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium mt-5"
        >
          {{ user.name }}
        </div>
        <div
          class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary"
        >
          {{ user.email }}
        </div>
      </div>
    </div> -->
  </ng-container>

  <!-- Navigation footer hook -->
  <!-- <ng-container fuseVerticalNavigationContentFooter>
    <div
      class="flex flex-0 items-center justify-center h-16 pr-6 pl-2 mt-2 mb-4 opacity-12"
    >
      <img class="max-w-36" src="assets/images/logo/logo-text-on-dark.svg" />
    </div>
  </ng-container> -->
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">
  <!-- Header -->
  <div
    class="header-container relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
    <!-- <h1>{{user.companyName}}</h1> -->
    <h2
      class="mx-1 w-full text-start text-base md:text-2xl font-semibold sm:text-2xl  tracking-tight leading-7 truncate"
      style="color: #204871;">
      {{user.companyName}}
    </h2>
    <!-- Access profile & Logout -->
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <button mat-icon-button [matMenuTriggerFor]="userActions">
        <span class="relative"><mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon></span>
      </button>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-col flex-auto">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Logout menu -->
  <mat-menu [xPosition]="'before'" #userActions="matMenu">
    <div mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>Signed in as</span>
        <span class="mt-1.5 text-md font-medium">{{ user.fullName }}</span>
      </span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <div mat-menu-item>
      <span class="flex flex-col leading-none">
        <span>User Layer</span>
        <span class="mt-1.5 text-md font-medium">{{ user.layerName }}</span>
      </span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <div mat-menu-item>
      <mat-icon [svgIcon]="'heroicons_outline:phone'"></mat-icon>
      <span>{{user.phoneNumber}}</span>
    </div>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
      <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
      <span>Sign out</span>
    </button>
  </mat-menu>
</div>